import {FC} from 'react'
import {Modal} from 'react-bootstrap'
import {ShipmentTrends} from '../components/ShipmentTrends'
import {OrganizationAnalyticsFilters} from '../helpers/organizationAnalyticsHelpers'

type Props = OrganizationAnalyticsFilters & {
  show: boolean
  handleClose: () => void
}

const ShipmentTrendsModal: FC<Props> = ({show, handleClose, ...analyticsFilters}) => {
  return (
    <Modal
      id='gori_modal_shipment_trends'
      tabIndex={-1}
      aria-hidden='true'
      centered
      dialogClassName='modal-size-xl h-auto'
      contentClassName='modal-padding'
      show={show}
      backdrop='static'
      onHide={handleClose}
    >
      <Modal.Header closeButton className='border-0 pb-0' />
      <Modal.Body className='pt-0'>
        <ShipmentTrends className='shadow-none border-0' {...analyticsFilters} />
      </Modal.Body>
    </Modal>
  )
}

export {ShipmentTrendsModal}
